import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import sentryService from './services/sentry.service';

(async function initApp() {
  const shouldUseMSW =
    import.meta.env.MODE === 'development' && import.meta.env.VITE_SKIP_MOCK_SERVICE_WORKER !== 'true';
  if (shouldUseMSW) {
    const { startWorker } = await import('./tests/mock.browser');
    await startWorker();
  }

  const isRemoteEnv = import.meta.env.VITE_DEPLOYMENT_TARGET !== 'LOCAL';
  if (isRemoteEnv) {
    sentryService.init();

    // Add global error handlers
    window.addEventListener('error', (event) => {
      console.error('Global error:', event.error);
      sentryService.captureException(event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      sentryService.captureException(new Error(event.reason));
    });
  }

  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
})();
